/** 閲覧申請：ステータス 未申請 */
export const VIEW_REQUEST_STATUS_DEFAULT = {
    label: '詳細閲覧を申請する',
    short: '詳細閲覧申請',
    value: null,
};
/** 閲覧申請：ステータス 申請中 */
export const VIEW_REQUEST_STATUS_UNAPPROVED = {
    label: '詳細閲覧を申請中',
    short: '詳細閲覧申請中',
    value: 1,
};
/** 閲覧申請：ステータス 承認 */
export const VIEW_REQUEST_STATUS_APPROVAL = {
    label: '提案依頼を承認',
    short: '提案依頼承認',
    value: 2,
};
/** 閲覧申請：ステータス 不承認 */
export const VIEW_REQUEST_STATUS_DISAPPROVED = {
    label: '申請は承認されませんでした',
    short: '提案依頼不承認',
    value: 3,
};
/** 閲覧申請：ステータス 決済終了 */
export const VIEW_REQUEST_STATUS_END = {
    label: '詳細閲覧決済を終了',
    short: '詳細閲覧決済終了',
    value: 4,
};
/** 閲覧申請：ステータスの一覧 */
export const VIEW_REQUEST_STATUSES = [
    VIEW_REQUEST_STATUS_DEFAULT,
    VIEW_REQUEST_STATUS_UNAPPROVED,
    VIEW_REQUEST_STATUS_APPROVAL,
    VIEW_REQUEST_STATUS_DISAPPROVED,
    VIEW_REQUEST_STATUS_END,
];
